import { render, staticRenderFns } from "./PreferencesModule.vue?vue&type=template&id=3b512b3f&scoped=true"
import script from "./PreferencesModule.vue?vue&type=script&lang=js"
export * from "./PreferencesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b512b3f",
  null
  
)

export default component.exports